// 中文包
module.exports = {
  common: {
    edit: "编辑",
    apply: "申请",
    activate: "激活",
    delete: "删除",
    cancel: "取消",
    success: "成功",
    fail: "失败",
    save: "保存",
    ensure: "确定",
    submit: "提交",
    remark: "备注",
    detail: "查看",
    action: "操作",
    open: "开启",
    close: "关闭",
    back: "返回",
    export: "导出",
    modify: "修改",
    layout: "退出登录",
    noListData: "列表无数据",
    more: "详情",
    add: "新增",
    delSuccess: "删除成功！",
    addFailure: "添加失败！",
    logOut: "注销",
    delAllInfo: "是否继续执行删除操作？",
    saveTip: "您还未保存页面内容，是否继续离开?",
    tip: "提示",
    yes: "是",
    no: "否",
    delTip: "勾选激活",
    batchDelete: "批量删除",
    search: "查询",
    permission: "暂无权限，请返回",
    reset: "重置",
  },
  breadcrumbItem: {
    home: "名字列表配置",
    data: "设备通用配置打包",
    alarm: "防区配置",
    house: "户型图配置",
    name: "名字列表配置",
  },
  errorRes: {
    res82: "系统繁忙，请稍后再试",
  },

  openConfig: {
    title: "设备通用配置",
    version: "协议版本",
    versionTip: "请选择协议版本",
    checkVersion: "协议版本不得为空，请重新选择",
    signType: "签名算法类型",
    checkSignType: "签名算法类型不得为空，请重新选择",
    fileLabel: "选择文件",
    addFile: "添加文件",
    fileName: "文件名",
    zipType: "压缩文件方式",
    noZip: "不压缩",
    noFile: "暂未添加文件",
    checkFile: "配置文件为空，请添加文件",
    name: "名字",

    nameTip: "输入长度为1-10位",
    checkName: "名字不得为空，请重新输入",
    checkName1: "名字输入有误，请重新输入",
    room: "设备编号",
    roomTip: '输入长度为1-24位，通过"-"区分层级',
    checkRoom: "设备编号不得为空，请重新输入",
    checkRoom1: "设备编号输入有误，请重新输入",
    pic: "图片",
    add: "添加",
    reset: "重置",
    picTip: "图片文件最大上传3m",
    checkPic: "图片文件不得为空，请重新选择",
    imgRegTip: "只允许上传jpg、jpeg、png格式的文件",
    excRegTip: "只允许上传xls、xlsx格式的文件",
    zipRegTip: "只允许上传zip格式的文件",
    produce: "生成配置文件",
    confType: "配置类型",
    pack: "打包",
    batchAdd: "批量添加",
    singleAdd: "单个添加",
    modelBatch: "下载批量导入模板",
    uploadInfo: "上传基础信息Excel",
    uploadPic: "上传图片包Zip",
    addName: "添加单条数据",
    sameTip: "序号：",
    sameTip1: "的设备编号重复",
    modelError: "上传的基础信息文件内容不正确，请对照模板修改文件",
    noPic: "列表中有未添加图片的数据，需补全图片后再生成配置文件",
    picBtnTip: "请先上传基础信息文件",
    devType: "设备类型",
    devTypeTip: "请选择设备类型",
    checkDevType: "设备类型不得为空，请重新选择",
    indexName: "序号",
    IS: "室内机",
    GU: "管理机",
    OS1: "门口机",
    OS2: "围墙机",
    OS3: "小门口机",
    nameListTip:
      "上传的基础数据中，存在名称字段不完整的数据，其余正确数据已导入",
    numListTip:
      "上传的基础数据中，存在设备编号字段不完整的数据，其余正确数据已导入",
  },
  alarm: {
    ad: "AD防区",
    io: "IO防区",
    alarmPlus: "防区扩展",
    num: "编号",
    open: "开",
    close: "关",
    machine: "探测器类型",
    sendType: "触发类型",
    mode: "模式",
    mType1: "红外",
    mType2: "门磁",
    mType3: "窗磁",
    mType4: "瓦斯",
    mType5: "烟雾",
    mType6: "门铃",
    mType7: "手报按钮",
    mType8: "红外门磁",
    mType9: "手报门磁",
    mType10: "振动",
    mType11: "气压",
    mType12: "其他",
    send1: "24小时即报",
    send2: "延时报警",
    send3: "传递延时",
    send4: "立即报警",
    send5: "交叉报警",
    mode1: "常开",
    mode2: "常关",
    presence: "在家",
    leaving: "离家",
    timeSet: "布防相关时间设置",
    delayTime: "布防生效延时（秒）",
    startDelay: "报警触发延时（秒）",
    startUtil: "报警持续时间（分）",
    associated: "关联防区",
  },
  house: {
    dev: "设备",
    scene: "场景",
    vine: "传感器",
    single: "独立控制场景",
    light: "灯光",
    air: "空调",
    heat: "地暖",
    fresh: "新风",
    switch: "开关插座",
    curtain: "窗帘",
    water: "热水器",
    bgm: "背景音乐",
    cust: "自定义设备",

    slight: "灯光",
    sAir: "空调",
    sHeat: "地暖",
    sFresh: "新风",
    sSwitch: "开关插座",
    sCurtain: "窗帘",
    sWater: "热水器",
    sBgm: "背景音乐",
    sCust: "自定义设备",

    IndependentControl: "独立控制场景",
    scene1: "场景1",
    scene2: "场景2",
    scene3: "场景3",
    scene4: "场景4",
    scene5: "场景5",
    scene6: "场景6",
    scene7: "场景7",
    scene8: "场景8",
    temp1: "温度",
    temp2: "湿度",
    temp3: "甲烷",
    temp4: "有机气体",
    picTip: "暂无户型图",
    upload: "上传户型图",
    imgSize: "单张户型图的图片大小不得超过10M",
    imgName: "上传的户型图文件名称不得出现中文，请重新选择",
    imgLength: "户型图上传添加总数不得超过8张，已自动选择文件夹中的前8张图片",
    imgCheckTip: "户型图不匹配，请重新上传",
    room1: "户型图1",
    room2: "户型图2",
    room3: "户型图3",
    room4: "户型图4",
    room5: "户型图5",
    room6: "户型图6",
    room7: "户型图7",
    room8: "户型图8",
    download: "导出",
    input: "导入配置",
    title: "设备参数表",
    name: "名称",
    location: "位置",
    start: "启动",
    see: "可见",
    noSee: "不可见",
    belong: "所属",
    bgIcon: "蓝灰图标",

    vineTip: "请选择户型图后，再进行设置温控属性",
    sceneTip: "请选择户型图后，再进行设置场景属性",
    dragTip: "请选择户型图后，再进行拖动操作",

    editTip: "编辑成功",
    addTip: "上传时，需要一次性选中所有户型图",

    editError: "请指定编辑内容后，再进行编辑",
    delError: "请指定删除内容后，再进行删除",
    delTip: "删除成功",
    imgAddTip: "户型图上传添加总数已达8张，无法再添加",
    houseTitle: "户型图切换：",
    delHouseTip: "此操作将删除该张户型图以及配置内容，是否继续？",
    sendTip: "导入配置内容进行再次修改，可上传 xml 文件",
    checkType: "上传的文件格式错误，请检查文件内容后重新上传",
    importTip: "导入配置文件",
    importTip1: "导入相应户型图",
    upLoadBtn: "上传",
    picContent: "户型图上传顺序，需要与配置文件中户型图排序一致",
    successFile: "配置文件上传成功",
    vineTipCheck: "名称不得为空，请确认输入",

    picNumMax:
      "请确认导入图片的数量，当前导入图片数量大于配置文件中户型图数量，请重新选择",
    picNumMin:
      "请确认导入图片的数量，当前导入图片数量小于配置文件中户型图数量，请重新选择",

    maxSizeTip:
      "该类型添加数量或添加总数超出限制，若需添加，请先整理已添加的设备或场景",

    devNameTip: "请输入名称",
    chromeTip: "建议使用Chrome浏览器",
    downTip: "点击跳转下载链接",
    imgRegTip: "只允许上传jpg、jpeg格式的文件",
    threeTitle: "三恒系统",
    mainControl: "主控",
    sedControl: "分控",
    controlBtn: "配置",
    configEdit: "三恒系统配置详情",
    moveTip: "图标请拖动至户型图区域内，请重新拖动",
    repeatNameTip: "不能上传相同名称的户型图，请重新选择",
    space: "（预留）",
  },
  updateConfig: {
    tip0: "当设置24小时即报时，设置开关为开",
    tip1: "当设置24小时即报时，应设置开关为开",
    tip2: "当设置立即报警时，应设置开关为开",
    tip3: "延时报警关闭时，传递延时需设置为关闭",
    tip4: "已设置交叉报警，需要关联操作",
    tip5: "请先开启延时报警",
    tip6: "当设置立即报警时，设置开关为开",
  },
  audio: {
    title: "语音提示打包工具",
    lock: "开锁提示音",
    call: "呼叫提示音",
    speak: "通话提示音",
    busy: "忙提示音",
    tip1: "点击上传.wav格式文件",
    tip2: "文件大小不超1M",
    tip3: "请上传.wav格式文件",
    tip4: "请上传全部文件",
    add: "生成文件",
  },
  threeProject: {
    hotWater: "热水系统",
    cho: "甲醛",
    config: "配置",
    unconfig: "不配置",
  },
  elevator: {
    title: "梯控配置生成",
    label: "上传梯控配置表",
    uploadTip: "点击或拖拽文件到此处上传",
    upload: "上传",
    download: "下载模板",
    downloadTip: "点击下载梯控配置表模板",
    error1: "【物理楼层】有误请检查配置文件后重新导入",
    error2: "【显示楼层】有误请检查配置文件后重新导入",
    error3: "【梯控网关地址】有误请检查配置文件后重新导入",
    error4: "【梯号显示】有误请检查配置文件后重新导入",
    error5: "【设备IP】有误请检查配置文件后重新导入",
    error6: "【梯控网关】数量超限请检查配置文件后重新导入",
    generate: "梯控配置表模板",
    fileLabel: "梯控配置文件：",
    tip: "请把配置文件放于PC工具中的【资源升级】导入至设备",
    downloadfile: "下载",
    fileName: "梯控配置文件.xlsx",
    formatError: "上传的文件格式错误，请检查文件内容后重新上传",
  },
};
